/**
 * Shared props for money / asking-price `<Input>` elements.
 *
 * iOS Safari heuristically treats numeric inputs inside modal dialogs as
 * possible credential fields and pops the "Use saved password?" sheet.
 * Spread these props onto every price input so iOS (and 1Password /
 * LastPass browser extensions) leaves them alone.
 *
 * Keep `type="text"` + `inputMode="decimal"` at the call site — do NOT use
 * `type="number"`, which breaks decimal keypads on iOS and doesn't fix the
 * credential heuristic anyway.
 */
export const PRICE_INPUT_PROPS = {
  name: 'price',
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: false,
  'data-1p-ignore': true,
  'data-lpignore': 'true',
} as const;
